import store from '@/store';
import { computed, Ref } from '@vue/composition-api';

export interface IUseHandleDrawer {
  handleDrawerClick: () => void,
  getDrawerActive: Ref<boolean>,
  handleInfoDrawerClick: () => void,
  getInfoDrawerActive: Ref<boolean>,
  drawerChange: (open: boolean) => void,
  drawerInfoChange: (open: boolean) => void,
}

const useHandleDrawer = (): IUseHandleDrawer => {
  const handleDrawerClick = () => store.commit('flipDrawerActive');
  const getDrawerActive: Ref<boolean> = computed((): boolean => store.getters.getDrawerActive);
  const handleInfoDrawerClick = () => store.commit('flipInfoDrawerActive');
  const getInfoDrawerActive: Ref<boolean> = computed((): boolean => store.state.infoDrawerActive);

  const drawerChange = (open: boolean) => {
    if (!open) {
      store.commit('updateDrawerActive', open);
    }
  };

  const drawerInfoChange = (open: boolean) => {
    if (!open) {
      store.commit('updateInfoDrawerActive', open);
    }
  };

  return {
    handleDrawerClick,
    getDrawerActive,
    handleInfoDrawerClick,
    getInfoDrawerActive,
    drawerChange,
    drawerInfoChange,
  };
};

export default useHandleDrawer;
